import React from "react";
import { Truck, CheckCircle } from "@phosphor-icons/react";
import { ZAR } from "@/lib/cart";

export default function FreeShipProgress({ subtotal, threshold = 500 }) {
  const remaining = Math.max(0, threshold - subtotal);
  const pct = Math.min(100, (subtotal / threshold) * 100);
  const done = remaining === 0;

  return (
    <div className="border border-white/10 bg-[#0d0d0d] p-4" data-testid="free-ship-bar">
      <div className="flex items-center gap-2 text-sm">
        {done ? (
          <>
            <CheckCircle size={18} weight="duotone" className="text-[#00FFC2]" />
            <span className="text-[#00FFC2] font-label text-xs">FREE DELIVERY UNLOCKED</span>
          </>
        ) : (
          <>
            <Truck size={18} weight="duotone" className="text-[#FF5A1F]" />
            <span className="text-white/80">
              Add <b className="text-[#FF5A1F]">{ZAR(remaining)}</b> more for{" "}
              <b>free delivery</b>
            </span>
          </>
        )}
      </div>
      <div className="mt-3 h-1.5 w-full overflow-hidden bg-white/10">
        <div
          className="h-full bg-gradient-to-r from-[#FF5A1F] to-[#00FFC2] transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
